import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { useIntl } from '../../util/reactIntl';
import { languagesHelper as language } from '../../util/languages';
import { getCountryFlagById } from '../../util/getCountryFlag';
import { getLanguageFlagById } from '../../util/getLanguageFlag';

import { ReviewRatingCustom, IconMapPreview } from '../../components';

import css from './ListingPage.module.css';
import classNames from 'classnames';

const getLocalizedPublicData = (listingTranslation, publicData, key, locale) =>
  listingTranslation?.[`${key}_locale_${locale}`] || publicData?.key;

const getAnchorOffset = () => {
  if (typeof window === 'undefined') {
    return 84;
  }
  // Match Topbar height + padding used elsewhere on ListingPage
  return window.matchMedia('(min-width: 768px)').matches ? 96 : 84;
};

const SectionMainInfo = props => {
  const {
    listing,
    reviews = [],
    config,
    mainInfoFields = [],
    locale,
    listingTranslation
  } = props;

  const intl = useIntl();
  const { publicData = {}, geolocation = null } = listing?.attributes || {};

  const {
    field_landscape,
    linstingFieldId_country,
  } = publicData;

  const rating = publicData?.currentRating;

  return (
    <div className={css.mainInfo}>
      <div className={css.leftCorner} />
      <div className={css.rightCorner} />

      <div className={css.location}>
        <AnchorLink href="#listing-location" offset={getAnchorOffset} className={css.locationMap}>
          <IconMapPreview />
        </AnchorLink>

        <div className={css.locationInfo}>
          {field_landscape && field_landscape !== "not-active-in-my-area" && field_landscape !== "no-but-i-am-a-member-of-ERN" && (
            <div className={css.mainInfoLabel}>
              {language.labelsTranslator(field_landscape, intl)}
            </div>
          )}

          <div className={css.mainInfoValue}>
            {linstingFieldId_country && (
              <span className={css.flag}>
                {getCountryFlagById(linstingFieldId_country)}
              </span>
            )}
            {language.labelsTranslator(linstingFieldId_country, intl)}
          </div>
        </div>
      </div>

      {mainInfoFields.map(field => {
        const { key, label, value, durationUnit } = field;

        const isLanguagesField = key === 'listingField_languages';

        const translatedArrayValue = Array.isArray(value)
          ? value.map(v => language.labelsTranslator(v, intl)).join(', ')
          : null;

        const localizedValue =
          durationUnit === 'session'
            ? value
            : translatedArrayValue ??
              getLocalizedPublicData(listingTranslation, publicData, key, locale) ??
              value;

        if (!value) return null;

        return (
          <div className={classNames(css.mainInfoItem, key === "field_difficulty" && css.mainInfoItemWide)} key={key}>
            <div className={css.mainInfoLabel}>
              {intl.formatMessage({ id: label })}
            </div>

            <div className={css.mainInfoValue}>
              {isLanguagesField && Array.isArray(value)
                ? value.map((langId, index) => (
                    <span key={langId}>
                      {index > 0 && ', '}
                      <span className={css.flag}>{getLanguageFlagById(langId)}</span>
                      {language.labelsTranslator(langId, intl)}
                    </span>
                  ))
                : localizedValue}
              {key === 'field_duration' && durationUnit === 'days' && (
                <span className={css.days}>
                  {intl.formatMessage({ id: 'ListingPage.durationDays' }, { count: value })}
                </span>
              )}
            </div>
          </div>
        );
      })}

      {rating && (
        <AnchorLink href="#listing-reviews" offset={getAnchorOffset} className={css.reviews}>
          <div className={css.mainInfoLabel}>
            {intl.formatMessage({ id: 'ListingPage.reviews' })}
          </div>

          <div className={css.mainInfoValue}>
            <ReviewRatingCustom
              rating={rating}
              className={css.ratingStars}
              variant="white"
            />
            {rating.toFixed(1)}
          </div>
        </AnchorLink>
      )}
    </div>
  );
};

export default SectionMainInfo;
